import { ColorVariant } from '@workwhile/ui/dist/colors'
import { useGlobalWorkflowsContextValue } from 'global-workflows/GlobalWorkflowManager/GlobalWorkflowManager'
import { Circle, CircleCheckBig, CircleSlash2, LucideIcon } from 'lucide-react'
import { useShiftAssessments } from 'queries/user'
import React, { useMemo } from 'react'
import { ActionIcon } from './ActionIcon'

export const AssessmentWorkflowIcon = ({
  worker,
  shiftId,
}: {
  worker: { id: number; name: string }
  shiftId: number
}) => {
  const { assessmentWorkflow } = useGlobalWorkflowsContextValue()
  const { data: assessments } = useShiftAssessments(shiftId)
  const assessment = assessments?.assessmentsByWorkerId?.[worker.id]

  const config: { icon: LucideIcon; color: ColorVariant } | null =
    useMemo(() => {
      switch (assessment?.status) {
        case 'pass':
          return { icon: CircleCheckBig, color: 'success' }
        case 'fail':
          return { icon: CircleSlash2, color: 'error200' }
        case 'needs_evaluation':
          return { icon: Circle, color: 'primary200' }
        default:
          return null
      }
    }, [assessment?.status])

  if (!assessment) {
    return null
  }
  if (!config) {
    return null
  }

  return (
    <ActionIcon
      icon={config.icon}
      onClick={() =>
        assessmentWorkflow.open({
          evaluationNote: assessment.evaluationNote ?? '',
          assessments: {
            workerAssessment: assessment,
            requirements: assessments.requirements,
          },
          worker,
          shiftId,
        })
      }
      color={config.color}
      title="Evaluate Assessment"
    />
  )
}
